import { render, staticRenderFns } from "./licenseVerification.vue?vue&type=template&id=04606954"
import script from "./licenseVerification.vue?vue&type=script&lang=js"
export * from "./licenseVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports